@if (!loading) {
  <h1 class="pb-4">{{ content.logInHeadline }}</h1>
  <form>
    <div class="form-group">
      <label class="sr-only" for="loginEmail">Email</label>
      <input type="email" class="form-control"
        [ngClass]="{'is-invalid' : formService.controlHasError( signInForm.get('email'), 'required')}"
        [formControl]="signInForm.get('email')"
        id="loginEmail" placeholder="Email">
      @if (formService.controlHasError( signInForm.get('email'), 'required')) {
        <span
          class="form-control-feedback">Email is required
        </span>
      }
    </div>
    <div class="form-group">
      <label class="sr-only" for="loginPassword">Password</label>
      <input type="password"
        [ngClass]="{'is-invalid' : formService.controlHasError( signInForm.get('password'), 'required')}"
        [formControl]="signInForm.get('password')"
        class="form-control" id="loginPassword" placeholder="Password">
      @if (formService.controlHasError( signInForm.get('password'), 'required')) {
        <span
          class="form-control-feedback">Password is required
        </span>
      }
    </div>
    <button class="btn btn-block btn-primary" (click)="submitForm()">Log In</button>
    <div class="mt-4 text-center">
      <a [routerLink]="'/forgot-password'">Forgot Password?</a><br/>
      <a [routerLink]="'/signup'">New to Much Smarter? Sign Up</a>
    </div>
  </form>
} @else {
  <div class="center-div">
    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
  </div>
}

<app-feedback></app-feedback>

